<div
  data-testid="translations"
  class="mx-5"
>
  <header class="d-flex align-items-center justify-content-between sticky-top bg-white py-3 border-bottom">
    <div class="d-flex align-items-center gap-3">
      <h1 class="h2 mb-1">{{ "navigationTranslations" | localize }}</h1>
    </div>

    <div class="d-flex align-items-center gap-4">
      <action-button
        buttonType="button"
        [buttonLabel]="'translationsSaveButtonLabel'"
        buttonClass="btn btn-primary"
        [testId]="'save-translations-button'"
        (buttonClick)="saveTranslations()"
      ></action-button>

      <div class="d-flex align-items-center gap-2">
        <action-button
          buttonType="button"
          [buttonLabel]="'translationsAddLanguageButtonLabel'"
          buttonClass="btn btn-outline-primary"
          [testId]="'add-language-button'"
          [buttonDisabled]="addingTranslation"
          (buttonClick)="openAddLanguageModal()"
        ></action-button>

        <action-button
          buttonType="button"
          [buttonLabel]="'translationsAddTranslationButtonLabel'"
          [actionInProgressLabel]="'translationsAddTranslationInProgressLabel'"
          buttonClass="btn btn-outline-primary"
          [testId]="'add-translation-button'"
          [actionInProgress]="addingTranslation"
          (buttonClick)="translationFileInput.click()"
        ></action-button>

        <input
          #translationFileInput
          type="file"
          accept="application/json"
          class="d-none"
          [attr.data-testid]="'add-translation-file-input'"
          (change)="importTranslation(getFirstSelectedFile($event)); translationFileInput.value = ''"
        />
      </div>
    </div>
  </header>

  <form class="d-flex flex-column gap-4 pt-4">
    <section *ngFor="let group of groups">
      <h2 class="h6 mb-3">{{ group.key }}</h2>

      <div class="input-group mb-2" *ngFor="let language of supportedLanguages">
        <span class="input-group-text">{{ language.flag }}</span>
        <input
          [attr.data-testid]="'translation-' + language.code + '-' + group.key"
          type="text"
          class="form-control"
          [value]="group.translations[language.code]"
          (input)="group.translations[language.code] = $any($event.target).value"
        />
      </div>
    </section>
  </form>
</div>

<ng-template #addLanguageModal>
  <div data-testid="add-language-modal">
  <div class="modal-header">
    <h2 class="modal-title h5">{{ "addLanguageModalTitle" | localize }}</h2>
  </div>
  <div class="modal-body">
    <div class="input-group">
      <span class="input-group-text">{{ "addLanguageModalLanguageLabel" | localize }}</span>
      <app-select
        [inForm]="true"
        [value]="selectedNewLanguage"
        [options]="newLanguageOptions"
        [testId]="'new-language'"
        (valueChanged)="handleNewLanguageChange($event)"
      ></app-select>
    </div>
  </div>
  <div class="modal-footer d-flex justify-content-between">
    <action-button
      buttonType="button"
      [buttonLabel]="'modalResponseCancel'"
      buttonClass="btn btn-secondary"
      [testId]="'cancel-add-language-button'"
      (buttonClick)="closeAddLanguageModal()"
    ></action-button>

    <action-button
      buttonType="button"
      [buttonLabel]="'addLanguageModalConfirmButtonLabel'"
      buttonClass="btn btn-primary"
      [testId]="'confirm-add-language-button'"
      (buttonClick)="addNewLanguage()"
    ></action-button>
  </div>
  </div>
</ng-template>
